<div class="sub-group-wrapper" [ngClass]="{'expanded': expanded && showExpandedBorder()}">
    <div class="column-100">
        <div class="component-accordion">
            <div class="header" [ngClass]="{'no-padding': noPadding()}" (click)="onExpandClicked()">
                <h2>{{headerText()}}</h2>
                <div class="info-panel">
                    <div class="counter" [ngClass]="{'expanded': expanded}">{{infoText()}}</div>
                    <ev-expanded-icon [expanded]="expanded" [size]="22" [padding]="'0px 34px 0px 0px'"></ev-expanded-icon>
                </div>
            </div>
            <div class="content table" [class.expanded]="expanded">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>